export default [
  { name: "Afghanistan", code: "af"},
  { name: "Ägypten", code: "eg"},
  { name: "Åland", code: "ax"},
  { name: "Albanien", code: "al"},
  { name: "Algerien", code: "dz"},
  { name: "Amerikanisch-Samoa", code: "as"},
  { name: "Andorra", code: "ad"},
  { name: "Angola", code: "ao"},
  { name: "Anguilla", code: "ai"},
  { name: "Antigua und Barbuda", code: "ag"},
  { name: "Äquatorialguinea", code: "gq"},
  { name: "Argentinien", code: "ar"},
  { name: "Armenien", code: "am"},
  { name: "Aruba", code: "aw"},
  { name: "Aserbaidschan", code: "az"},
  { name: "Äthiopien", code: "et"},
  { name: "Australien", code: "au"},
  { name: "Bahamas", code: "bs"},
  { name: "Bahrain", code: "bh"},
  { name: "Bangladesch", code: "bd"},
  { name: "Barbados", code: "bb"},
  { name: "Weißrussland", code: "by"},
  { name: "Belgien", code: "be"},
  { name: "Belize", code: "bz"},
  { name: "Benin", code: "bj"},
  { name: "Bermuda", code: "bm"},
  { name: "Bhutan", code: "bt"},
  { name: "Bolivien", code: "bo"},
  { name: "Bosnien und Herzegowina", code: "ba"},
  { name: "Botswana", code: "bw"},
  { name: "Bouvetinsel", code: "bv"},
  { name: "Brasilien", code: "br"},
  { name: "Britische Jungferninseln", code: "vg"},
  { name: "Brunei", code: "bn"},
  { name: "Bulgarien", code: "bg"},
  { name: "Burkina Faso", code: "bf"},
  { name: "Burundi", code: "bi"},
  { name: "Chile", code: "cl"},
  { name: "Volksrepublik China", code: "cn"},
  { name: "Cookinseln", code: "ck"},
  { name: "Costa Rica", code: "cr"},
  { name: "Curaçao", code: "cw"},
  { name: "Dänemark", code: "dk"},
  { name: "Deutschland", code: "de"},
  { name: "Dominica", code: "dm"},
  { name: "Dominikanische Republik", code: "do"},
  { name: "Dschibuti", code: "dj"},
  { name: "Ecuador", code: "ec"},
  { name: "Elfenbeinküste", code: "ci"},
  { name: "El Salvador", code: "sv"},
  { name: "Eritrea", code: "er"},
  { name: "Estland", code: "ee"},
  { name: "Swasiland", code: "sz"},
  { name: "Falklandinseln", code: "fk"},
  { name: "Färöer", code: "fo"},
  { name: "Fidschi", code: "fj"},
  { name: "Finnland", code: "fi"},
  { name: "Frankreich", code: "fr"},
  { name: "Französisch-Guayana", code: "gf"},
  { name: "Französisch-Polynesien", code: "pf"},
  { name: "Gabun", code: "ga"},
  { name: "Gambia", code: "gm"},
  { name: "Georgien", code: "ge"},
  { name: "Ghana", code: "gh"},
  { name: "Gibraltar", code: "gi"},
  { name: "Grenada", code: "gd"},
  { name: "Griechenland", code: "gr"},
  { name: "Grönland", code: "gl"},
  { name: "Guadeloupe", code: "gp"},
  { name: "Guam", code: "gu"},
  { name: "Guatemala", code: "gt"},
  { name: "Guernsey (Kanalinsel)", code: "gg"},
  { name: "Guinea", code: "gn"},
  { name: "Guinea-Bissau", code: "gw"},
  { name: "Guyana", code: "gy"},
  { name: "Haiti", code: "ht"},
  { name: "Heard und McDonaldinseln", code: "hm"},
  { name: "Honduras", code: "hn"},
  { name: "Hongkong", code: "hk"},
  { name: "Indien", code: "in"},
  { name: "Indonesien", code: "id"},
  { name: "Insel Man", code: "im"},
  { name: "Irak", code: "iq"},
  { name: "Iran", code: "ir"},
  { name: "Irland", code: "ie"},
  { name: "Island", code: "is"},
  { name: "Israel", code: "il"},
  { name: "Italien", code: "it"},
  { name: "Jamaika", code: "jm"},
  { name: "Japan", code: "jp"},
  { name: "Jemen", code: "ye"},
  { name: "Jersey (Kanalinsel)", code: "je"},
  { name: "Jordanien", code: "jo"},
  { name: "Kaimaninseln", code: "ky"},
  { name: "Kambodscha", code: "kh"},
  { name: "Kamerun", code: "cm"},
  { name: "Kanada", code: "ca"},
  { name: "Kap Verde", code: "cv"},
  { name: "Kasachstan", code: "kz"},
  { name: "Katar", code: "qa"},
  { name: "Kenia", code: "ke"},
  { name: "Kirgisistan", code: "kg"},
  { name: "Kiribati", code: "ki"},
  { name: "Kokosinseln", code: "cc"},
  { name: "Kolumbien", code: "co"},
  { name: "Komoren", code: "km"},
  { name: "Kongo, Republik", code: "cg"},
  { name: "Korea, Nord", code: "kp"},
  { name: "Korea, Süd", code: "kr"},
  { name: "Kroatien", code: "hr"},
  { name: "Kuba", code: "cu"},
  { name: "Kuwait", code: "kw"},
  { name: "Laos", code: "la"},
  { name: "Lesotho", code: "ls"},
  { name: "Lettland", code: "lv"},
  { name: "Libanon", code: "lb"},
  { name: "Liberia", code: "lr"},
  { name: "Libyen", code: "ly"},
  { name: "Liechtenstein", code: "li"},
  { name: "Litauen", code: "lt"},
  { name: "Luxemburg", code: "lu"},
  { name: "Macau", code: "mo"},
  { name: "Madagaskar", code: "mg"},
  { name: "Malawi", code: "mw"},
  { name: "Malaysia", code: "my"},
  { name: "Malediven", code: "mv"},
  { name: "Mali", code: "ml"},
  { name: "Malta", code: "mt"},
  { name: "Marokko", code: "ma"},
  { name: "Marshallinseln", code: "mh"},
  { name: "Martinique", code: "mq"},
  { name: "Mauretanien", code: "mr"},
  { name: "Mauritius", code: "mu"},
  { name: "Mayotte", code: "yt"},
  { name: "Mexiko", code: "mx"},
  { name: "Mikronesien", code: "fm"},
  { name: "Moldau", code: "md"},
  { name: "Monaco", code: "mc"},
  { name: "Mongolei", code: "mn"},
  { name: "Montenegro", code: "me"},
  { name: "Montserrat", code: "ms"},
  { name: "Mosambik", code: "mz"},
  { name: "Myanmar", code: "mm"},
  { name: "Namibia", code: "na"},
  { name: "Nauru", code: "nr"},
  { name: "Nepal", code: "np"},
  { name: "Neukaledonien", code: "nc"},
  { name: "Neuseeland", code: "nz"},
  { name: "Nicaragua", code: "ni"},
  { name: "Niederlande", code: "nl"},
  { name: "Niger", code: "ne"},
  { name: "Nigeria", code: "ng"},
  { name: "Niue", code: "nu"},
  { name: "Nördliche Marianen", code: "mp"},
  { name: "Nordmazedonien", code: "mk"},
  { name: "Norfolkinsel", code: "nf"},
  { name: "Norwegen", code: "no"},
  { name: "Oman", code: "om"},
  { name: "Österreich", code: "at"},
  { name: "Osttimor", code: "tl"},
  { name: "Pakistan", code: "pk"},
  { name: "Palästina", code: "ps"},
  { name: "Palau", code: "pw"},
  { name: "Panama", code: "pa"},
  { name: "Papua-Neuguinea", code: "pg"},
  { name: "Paraguay", code: "py"},
  { name: "Peru", code: "pe"},
  { name: "Philippinen", code: "ph"},
  { name: "Pitcairninseln", code: "pn"},
  { name: "Polen", code: "pl"},
  { name: "Portugal", code: "pt"},
  { name: "Puerto Rico", code: "pr"},
  { name: "Réunion", code: "re"},
  { name: "Ruanda", code: "rw"},
  { name: "Rumänien", code: "ro"},
  { name: "Russland", code: "ru"},
  { name: "Salomonen", code: "sb"},
  { name: "Saint-Barthélemy", code: "bl"},
  { name: "Sambia", code: "zm"},
  { name: "Samoa", code: "ws"},
  { name: "San Marino", code: "sm"},
  { name: "São Tomé und Príncipe", code: "st"},
  { name: "Saudi-Arabien", code: "sa"},
  { name: "Schweden", code: "se"},
  { name: "Schweiz", code: "ch"},
  { name: "Senegal", code: "sn"},
  { name: "Serbien", code: "rs"},
  { name: "Seychellen", code: "sc"},
  { name: "Sierra Leone", code: "sl"},
  { name: "Simbabwe", code: "zw"},
  { name: "Singapur", code: "sg"},
  { name: "Sint Maarten", code: "sx"},
  { name: "Slowakei", code: "sk"},
  { name: "Slowenien", code: "si"},
  { name: "Somalia", code: "so"},
  { name: "Spanien", code: "es"},
  { name: "Sri Lanka", code: "lk"},
  { name: "St. Kitts und Nevis", code: "kn"},
  { name: "St. Lucia", code: "lc"},
  { name: "Saint-Pierre und Miquelon", code: "pm"},
  { name: "Südafrika", code: "za"},
  { name: "Sudan", code: "sd"},
  { name: "Südsudan", code: "ss"},
  { name: "Suriname", code: "sr"},
  { name: "Spitzbergen und Jan Mayen", code: "sj"},
  { name: "Syrien", code: "sy"},
  { name: "Tadschikistan", code: "tj"},
  { name: "Taiwan", code: "tw"},
  { name: "Tansania", code: "tz"},
  { name: "Thailand", code: "th"},
  { name: "Togo", code: "tg"},
  { name: "Tokelau", code: "tk"},
  { name: "Tonga", code: "to"},
  { name: "Trinidad und Tobago", code: "tt"},
  { name: "Tschad", code: "td"},
  { name: "Tschechien", code: "cz"},
  { name: "Tunesien", code: "tn"},
  { name: "Türkei", code: "tr"},
  { name: "Turkmenistan", code: "tm"},
  { name: "Turks- und Caicosinseln", code: "tc"},
  { name: "Tuvalu", code: "tv"},
  { name: "Uganda", code: "ug"},
  { name: "Ukraine", code: "ua"},
  { name: "Ungarn", code: "hu"},
  { name: "Uruguay", code: "uy"},
  { name: "Usbekistan", code: "uz"},
  { name: "Vanuatu", code: "vu"},
  { name: "Vatikanstadt", code: "va"},
  { name: "Venezuela", code: "ve"},
  { name: "Vereinigte Staaten", code: "us"},
  { name: "Vereinigtes Königreich", code: "gb"},
  { name: "Vietnam", code: "vn"},
  { name: "Wallis und Futuna", code: "wf"},
  { name: "Weihnachtsinsel", code: "cx"},
  { name: "Westsahara", code: "eh"},
  { name: "Zypern", code: "cy"},
];
